<template>
  <div class="container">
    <component
      :is="question.type"
      v-bind="question.data"
      :value="value"
      :expected-response="question.expectedResponse"
      @change="handleChange"
    />
  </div>
</template>

<script>
import ResponseComponents from './questions'


export default {
  name: 'TastingAnswer',
  props: {
    question: Object,
    value: String || Number || Array || Object
  },
  components: { ...ResponseComponents },
  methods: {
    /**
     * Notify the parent that the user response changed
     * @param {Object} payload
     * @param {any} payload.value
     * @param {boolean} payload.correct
     */
    handleChange(payload) {
      const value = payload.value
      const correct = payload.correct
      const id = this.question.id
      this.$emit('response', { value, correct, id })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 30px;
}

.scale {
  text-align: left;

  .wrapper {
    margin: 15px 0 20px;
    padding: 0 15px;
  }

  .title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .description {
    margin-bottom: 15px;
  }
}
</style>
